 /*=================================================================================================
  * @name: Popelt
  * @type: jQuery
  * @author: (c) Elton Jain - @eltonjain
  * @demo: http://welbour.com
  * @version: 1.0
  * @requires jQuery 1.9.1
  *=================================================================================================*/

 require(['jquery', 'Config'], function($, Config) {
     // imaginary global variables in scope

     function Popelt(params) {
         var _self = this;

         // If content is ID or HTML (from template engine), then don't add specific width, add base class
         // If content popup, option for title, content and buttons
         // If popup is Ajax, show inside cnt-wrap

         // popup class
         // content class
         // close class
         // title
         // content
         // from ID (eg. login popup)
         // from Ajax (eg. Login page)


         //////////////////////////////////////
         // VARIABLES
         //////////////////////////////////////
         var _d = UI.$d,
             _$w = UI.$w,
             _prefix = '__pop',
             _btnCloseClass = 'pop-btn-close',
             _closeClass = 'pop-close',
             _popBtnClass = 'pop-btn',
             _popClass = 'popup',
             _popContentClass = 'pop-wrap',
             _popActionBlockClass = 'pop-action-block',
             _popTitleClass = 'pop-title',
             _popBodyClass = 'pop-body',
             _id, _zIndex = 9000;

         //////////////////////////////////////
         // DEFAULTS
         //////////////////////////////////////
         var defaults = {};
         var o = $.extend(defaults, params);

         _self.init = function() {
             _popups = (_popups || 0) + 1;
             _id = _prefix + _popups + '__';
             _zIndex += _popups;
         };

         _self.setContent = function(content) {
             o.content = content;
             return _self;
         };

         _self.showPopup = function() {

         };

         _self.addButton = function(label, classname, clickEvent) {
             var btn = {
                 label: label
             };
             if ($.isFunction(classname)) {
                 clickEvent = classname;
                 classname = '';
             }
             btn.classname = classname;

             if ($.isFunction(clickEvent)) {
                 btn.clickEvent = clickEvent;
             } else {
                 btn.clickEvent = _self.close; // if no event, trigger popup close
             }
             o.buttons.push(btn);
             return btn;
         };

         // OK Button
         _self.addOKButton = function(clickEvent) {
             _self.addButton('OK', clickEvent);
         };
         // Cancel Button
         _self.addCancelButton = function() {
             _self.addButton('Cancel', _self.close);
         };
         // Close Button
         _self.addCloseButton = function() {
             _self.addButton('Close', _self.close);
         };

         _self.closePopup = function(e) {
             // closing specific popup if given, else 


             return false;
         };

         // Alias
         _self.show = _self.showPopup;
         _self.close = _self.closePopup;

         _self.init();

         return this;

         //////////////////////////////////////
         // PRIVATE FUNCTIONS
         //////////////////////////////////////
         function windowHeight() {
             return _w.innerHeight || _$w.height();
         }

         function windowWidth() {
             return _w.innerWidth || _$w.width();
         }

         function bindEvents() {
             // bind close buttons and overlay
             var popWrap = '.' + _popClass + '.' + _id,
                 popOverlay = "." + _popOverlayClass + '.' + _id;

             $(popWrap).on('click', '.' + _closeClass, _self.close);
             if (o.closeClass) {
                 o.closeClass = o.closeClass.replace('.', '');
                 $(popWrap).on('click', '.' + o.closeClass, _self.close);
             }

             if (o.closeButton === true) {
                 $(popWrap).on('click', '.' + _btnCloseClass, _self.close);
             }

             if (o.modal !== true) {
                 $('body').on('click', popOverlay + ', ' + popWrap, _self.close);
                 $('body').on('click', popWrap + ' .pop-block', function(e) {
                     e.stopPropagation();
                 });
             }

             if (o.escClose !== false) {
                 enableEscClose();
             }
             // recenter
             _$w.on('resize', recenter);
         }

         function unbindEvents(popupId) {
             // bind close buttons and overlay
             var popWrap = '.' + _popClass + '.' + popupId,
                 popOverlay = "." + _popOverlayClass + '.' + popupId;

             // popwrap and overlay click
             $(popOverlay + ', ' + popWrap).off('click');

             // close buttons click
             $(popWrap + '.' + _closeClass).off('click');
             if (o.closeClass) {
                 $(popWrap + '.' + o.closeClass.replace('.', '')).off('click');
             }
             //escape close
             _d.off('keydown.' + popupId);
         }

         function enableEscClose() {
             _d.on('keydown.' + _id, function(e) {
                 if (e.which == 27) { //escape
                     e.stopImmediatePropagation();
                     _self.close(_popup_current_id);
                     return false;
                 }
             });
         }

         function updateDomContent(content) {
             // set content directly into dom wrapper
             var contentContainer = '.' + _popClass + '.' + _id + ' .' + _popContentClass;
             _self.setContent(content);
             $(contentContainer).append(content);
             enableFocus();
             recenter();
         }

         function renderContent() {
             if (o.contentType == 'ajax' && o.loadUrl) {
                 // load URL via ajax
                 $.get(o.loadUrl, function(data) {
                     var content = $('<div class="pop-ajax-wrapper"></div>').append(data);
                     updateDomContent(content);
                     return false;
                 });

             } else if (o.contentType == 'iframe' && o.loadUrl) {
                 var iframe = $('<iframe class="pop-iframe"></iframe>');
                 iframe.attr('src', o.loadUrl);

                 iframe.css({
                     'border': 0,
                     'width': o.iframeWidth,
                     'height': o.iframeHeight
                 });

                 updateDomContent(iframe);
                 // dynamic height - coming soon

             } else if (parseInt(o.contentType.indexOf('#')) === 0) { // if template from #elementId
                 var content = $(o.contentType).html();
                 updateDomContent(content);
             }
         }

         function enableFocus() {
             var popup = '.' + _popClass + ' ' + '.' + _popContentClass;
             if (o.focus === true) {
                 $(popup).find('input,textarea').first().focus();
             }
         }

         function recenter() {
             // if valign is not false and offsetTop is not given
             if ((o.offsetTop !== '' && o.offsetTop >= 0) || o.valign === false) {
                 return false;
             }
             // do recenter
             var contentWrap = '.' + _popClass + '.' + _id + ' .pop-block',
                 _content_w = $(contentWrap).outerWidth(),
                 _content_h = $(contentWrap).outerHeight();

             _new_top = ((_wH - _content_h) / 2) - 20;
             _new_top = _new_top > 0 ? _new_top : 0;
             $('.' + _popClass + '.' + _id + ' .pop-container').css('margin-top', _new_top);
         }
     }

     Config.set('Popelt', Popelt);

     return Popelt;
 });
define("modules/common/Popup", function(){});

